import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FHEContainer } from 'data/components';
import { tools } from 'data/common';
import renderEnvComponent from 'data/common/renderEnvComponent';
import FormManagement from './Form/FormManagement';
import { addManagement } from '../../data/Managements/actions';

class ManagementAdd extends PureComponent {
    static propTypes = {
        addManagement: PropTypes.func.isRequired
    };

    addManagement = data => {
        const { addManagement } = this.props;
        return addManagement(data);
    };
    render() {
        return (
            <FHEContainer withBackIcon>
                <FormManagement type="add" sendDataFunc={this.addManagement} />
            </FHEContainer>
        );
    }
}

function mapStateToProps(state) {
    return {
        profile: state.data.user
    };
}

export default withRouter(
    renderEnvComponent(
        'scenes/Management/add',
        connect(
            mapStateToProps,
            (dispatch, ownProps) => bindActionCreators(tools.mergePropsToAction(ownProps.history.environment, { addManagement }), dispatch)
        )(ManagementAdd)
    )
);



// WEBPACK FOOTER //
// ./environments/genericEnv/scenes/Management/add.js